export const LOADING = 'LOADING'
export const LOADING_REMOVE = 'LOADING_REMOVE'

export const ERROR = 'ERROR'
export const ERROR_REMOVE = 'ERROR_REMOVE'
export const ERROR_CLEAR = 'ERROR_CLEAR'


export const NETWORK = 'NETWORK'

export const SUCCESS = 'SUCCESS'
export const SUCCESS_REMOVE = 'SUCCESS_REMOVE'
export const SUCCESS_CLEAR = 'SUCCESS_CLEAR'

export const PARTIAL = 'PARTIAL'
export const PARTIAL_REMOVE = 'PARTIAL_REMOVE'
export const PARTIAL_CLEAR = 'PARTIAL_CLEAR'

export const TOAST = 'TOAST'
export const TOAST_REMOVE = 'TOAST_REMOVE'

export interface BaseState {
    Loading: Loading[],
    Error: Error[],
    Success: Success[],
    Partial: Partial[],
    Toast: Toast[]
}

export interface Loading extends StateMensage{
}

/* eslint-disable no-unused-vars */
export enum StateType {
    Master,
    Local
}

export interface Error extends StateMensage{
}

export interface Network extends StateMensage{
}

export interface Success extends StateMensage{
}

export interface Partial extends StateMensage{
}

export interface Toast extends StateMensage{
}

export interface StateMensage{
    Name : string,
    Type : StateType,
    Message : string | undefined,
    CallBack : StateMensageCallBack | (()=>void)
}

export interface StateMensageCallBack {
    CallBackText:string,
    CloseText: string | null,
    CallBack : ()=>void | undefined
}

export interface LoadingAction {
    type: typeof LOADING,
    payload: Loading
}

export interface LoadingRemoveAction {
    type: typeof LOADING_REMOVE,
    payload: string
}

export interface ErrorAction {
    type: typeof ERROR,
    payload: Error
}

export interface ErrorRemoveAction {
    type: typeof ERROR_REMOVE,
    payload: string
}

export interface ErrorClearAction {
    type: typeof ERROR_CLEAR,
    payload: undefined
}

export interface NetworkErrorAction {
    type: typeof NETWORK,
    payload: Network
}


export interface SuccessAction {
    type: typeof SUCCESS,
    payload: Success
}

export interface SuccessRemoveAction {
    type: typeof SUCCESS_REMOVE,
    payload: number
}

export interface SuccessClearAction {
    type: typeof SUCCESS_CLEAR,
    payload: undefined
}


export interface PartialAction {
    type: typeof PARTIAL,
    payload: Partial
}

export interface PartialRemoveAction {
    type: typeof PARTIAL_REMOVE,
    payload: number
}

export interface PartialClearAction {
    type: typeof PARTIAL_CLEAR,
    payload: undefined
}

export interface ToastAction {
    type: typeof TOAST,
    payload: Toast
}

export interface ToastRemoveAction {
    type: typeof TOAST_REMOVE,
    payload: string
}



export type BaseActionTypes = LoadingAction | LoadingRemoveAction | ErrorAction | ErrorRemoveAction | ErrorClearAction | NetworkErrorAction | SuccessAction | SuccessRemoveAction | SuccessClearAction | PartialAction | PartialRemoveAction | PartialClearAction | ToastAction | ToastRemoveAction